var VersionModal = {};

VersionModal.showSubscribeBlock = function () {
  $('.error').show();
  $('.addVersionToCart').hide();
  $('.notifyMeAboutVersion').show();
};

VersionModal.hideSubscribeBlock = function () {
  $('.error').hide();
  $('.notifyMeAboutVersion').hide();
  $('.addVersionToCart').show();
};

VersionModal.toggleSelection = function (versions) {
  versions = Array.isArray(versions) ? versions : [versions];
  versions.forEach(function (version) {
    var el = VersionModal.$element.find('[data-version="' + version + '"]');
    var position = VersionModal.selected.indexOf(version);
    if (position >= 0) {
      VersionModal.selected.splice(position, 1);
      el.removeClass('active');
    } else {
      el.addClass('active');
      VersionModal.selected.push(version);
    }
  });
};

VersionModal.loadModal = function (productId, settings) {
  settings = settings || {};

  VersionModal.selected = [];

  jQuery.ajax({
    url: "/product/" + productId + "/versions",
    method: "get",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      if (VersionModal.$element) {
        VersionModal.$element.replaceWith(resp.html);
      }
      $("body").append(resp.html);
      VersionModal.$element = $('#chooseSize');

      VersionModal.$element.find(".addVersionToCart").click(function () {
        if (settings.onAddToCart && VersionModal.selected.length) {
          var items = VersionModal.selected.map(function (versionId) {
            return {type: "product", _id: productId, version: versionId, qty: 1};
          });
          settings.onAddToCart(items);
          VersionModal.$element.popup("hide");
        }
      });

      VersionModal.$element.find("[data-version]").each(function () {
        var isAvailable = this.getAttribute("data-available") === "true";
        var showSubscriptionPopup = this.getAttribute('data-subscribe-click') === "true";

        $(this).click(function (evt) {
          evt.preventDefault();
          var version = this.getAttribute("data-version");

          if (isAvailable) {
            VersionModal.toggleSelection(version);
            VersionModal.hideSubscribeBlock();
          } else {
            if (showSubscriptionPopup) {
              VersionModal.$element.popup("hide");
              Cart.showOutOfStockModel(this.innerText, version);
            } else {
              VersionModal.showSubscribeBlock();
            }
          }
        });
      });

      VersionModal.$element.popup('show');
    }
  });
};